import { Reveal } from "@/components/Reveal";

export function BrandBand() {
  return (
    <section className="relative bg-[#0F1012] py-20 lg:py-28" data-testid="brand-band">
      <Reveal>
        <div className="max-w-4xl mx-auto px-6 lg:px-10">
          <p className="font-mono-lux text-[10px] font-semibold uppercase tracking-[0.35em] text-amber-500 text-center mb-8">
            The House Mark — Pressed in Gold
          </p>
          <div className="border border-[#2E3340] bg-[#16181D] p-3 group">
            <img
              src="/images/brand-stationery.png"
              alt="AUREUS Executive Chauffeur brand stationery — embossed house mark"
              className="w-full h-auto object-contain group-hover:scale-[1.02] transition-transform duration-[1.6s] ease-out"
              data-testid="brand-band-image"
            />
          </div>
        </div>
      </Reveal>
    </section>
  );
}
